export default [
  /* Redirect */
  {
    path: '*',
    redirect: '/'
  },

  /* Dashboard */
  {
    path: '/',
    name: 'Dashboard',
    meta: {
      descricao: 'Dashboard'
    },
    component: () => import('@/pages/dashboard/Dashboard')
  }
]
